import { useQuery } from "react-query";
import DialogFullScreen from "../../../../components/DialogFullScreen";
import LoadingApiQuery from "../../../../components/LoadingApiQuery";
import axiosClient from "../../../../lib/axios";
import { IDataDetalharPublico } from "../../../../types/api/cadastros/detalhar-publico";
import { Grid, Skeleton, Box } from "@mui/material";
import CardResumo from "./CardResumo";
import { CardDadosGerais } from "./CardDadosGerais";
import CardLimiteConfigs from "./CardLimiteConfigs";
import CardFornecedorLeite from "./CardFornecedorLeite";
import { IPesquisarMovPublico } from "../../../../types/api/cadastros/pesquisar-movimentacao-publico";
import CardFornecedorMilho from "./CardFornecedorMilho";
import CardFornecedorSoja from "./CardFornecedorSoja";
import CardFornecedorCafe from "./CardFornecedorCafe";
import { useState } from "react";
import DialogLimiteUtilizado from "./DialogLimiteUtilizado";
import { CardUltimasCompras } from "./CardUltimasCompras";
import { CardTitulosReceber } from "./CardTitulosReceber";
import { CardCheques } from "./CardCheques";
import CardFazendas from "./CardFazendas";
import { SkeletonDetalhePublico } from "./SkeletonDetalhePublico";

export const DialogDetalhePublico = ({
    open,
    value,
    handleClose
}: DialogDetalhePublicoProps) => {
    const [openLimiteUtilizado, setOpenLimiteUtilizado] = useState<boolean>(false)
    const { data, isLoading } = useQuery({
        queryKey: ['cadastros/detalhar-publico', value],
        queryFn: () => axiosClient.get("/cadastros/detalhar-publico", {
            params: { publico_id: value }
        }),
        cacheTime: 0
    });
    const detalhe: IDataDetalharPublico = data?.data || null

    const { data: dataMov, isLoading: isLoadingMov } = useQuery({
        queryKey: ['cadastros/pesquisar-movimentacoes-publico', value],
        queryFn: () => axiosClient.get("/cadastros/pesquisar-movimentacoes-publico", {
            params: { publico_id: value }
        }),
        cacheTime: 0
    });
    const dataMovimentacao: IPesquisarMovPublico = dataMov?.data
    //

    return (
        <>
            <DialogFullScreen
                {...{ open, handleClose }}
                title="Detalhe do público"
            >
                {isLoading ? (
                    <SkeletonDetalhePublico />
                ) : (detalhe &&
                    <Grid container spacing={2}>
                        <Grid container size={{xs: 12, md: 4}} spacing={2} alignSelf="flex-start">
                            <Grid size={{xs:12}}>
                                <CardResumo data={detalhe} handleOpenDetalheLimiteUtilizado={() => { setOpenLimiteUtilizado(true) }} />
                            </Grid>
                            {
                                detalhe.limite_configuracoes.length > 0 &&
                                <Grid size={{xs:12}}>
                                    <CardLimiteConfigs configuracoes={detalhe.limite_configuracoes} />
                                </Grid>
                            }
                            {
                                detalhe.ultima_compra && detalhe.movimentos_por_ano.length > 0 &&
                                <Grid size={{xs:12}}>
                                    <CardUltimasCompras data={detalhe.movimentos_por_ano} ultima_compra={detalhe.ultima_compra} />
                                </Grid>
                            }

                            <Grid size={{xs:12}}>
                                {/* Box de informações fiscais */}
                            </Grid>
                        </Grid>

                        <Grid container size={{xs: 12, md: 8}} spacing={2} alignSelf="flex-start">
                            <Grid size={{xs:12}}>
                                <CardDadosGerais data={detalhe} />
                            </Grid>
                            {
                                detalhe.tipo_publico === "A" &&
                                <Grid size={{xs:12}}>
                                    <CardFazendas fazendas={detalhe.fazendas} />
                                </Grid>
                            }
                            {
                                detalhe.titulos_receber &&
                                <Grid size={{ xs: detalhe.cheque_pre_datado ? 6 : 12}}>
                                    <CardTitulosReceber data={detalhe.titulos_receber} />
                                </Grid>
                            }
                            {
                                detalhe.cheque_pre_datado &&
                                 <Grid size={{ xs: detalhe.cheque_pre_datado ? 6 : 12}}>
                                    <CardCheques data={detalhe.cheque_pre_datado} />
                                </Grid>
                            }
                            {
                                isLoadingMov &&
                                <Grid size={{xs:12}}>
                                    <LoadingApiQuery />
                                </Grid>
                            }
                            {
                                !isLoadingMov && dataMovimentacao?.fornecedor_leite &&
                                <Grid size={{xs:12}}>
                                    <CardFornecedorLeite fornecedor={dataMovimentacao.fornecedor_leite} />
                                </Grid>
                            }
                            {
                                !isLoadingMov && dataMovimentacao?.fornecedor_cafe &&
                                <Grid size={{xs:12}}>
                                    <CardFornecedorCafe fornecedor={dataMovimentacao.fornecedor_cafe} />
                                </Grid>
                            }
                            {
                                !isLoadingMov && dataMovimentacao?.fornecedor_milho &&
                                <Grid size={{xs:12}}>
                                    <CardFornecedorMilho fornecedor={dataMovimentacao.fornecedor_milho} />
                                </Grid>
                            }
                            {
                                !isLoadingMov && dataMovimentacao?.fornecedor_soja &&
                                <Grid size={{xs:12}}>
                                    <CardFornecedorSoja fornecedor={dataMovimentacao.fornecedor_soja} />
                                </Grid>
                            }
                            <Grid size={{xs:12}}>
                                {/* Box de informações fiscais */}
                            </Grid>
                        </Grid>
                    </Grid>
                )}
            </DialogFullScreen>
            {
                openLimiteUtilizado &&
                <DialogLimiteUtilizado
                    open={open}
                    handleClose={() => setOpenLimiteUtilizado(false)}
                    publico_id={value}
                />
            }
        </>
    )
}

interface DialogDetalhePublicoProps {
    open: boolean,
    handleClose: () => void,
    value: string
}

export interface CardProps {
    data: IDataDetalharPublico
}